import { createFileRoute, redirect } from '@tanstack/react-router'
import { RobotsPage } from '@/pages/robots/RobotsPage'
import { getRoutePermissionRule } from '@/constants/route-permissions'
import { getDefaultStore } from 'jotai'
import { permissionsAtom } from '@/store/auth.atom'

export const Route = createFileRoute('/_private/robots/')({
  beforeLoad: async () => {
    const pathname = '/robots'
    const rule = getRoutePermissionRule(pathname)
    if (!rule) return null

    const permissions = getDefaultStore().get(permissionsAtom)
    const allowed =
      rule.kind === 'single'
        ? permissions.includes(rule.permission)
        : rule.permissions.some((p) => permissions.includes(p))

    if (!allowed) {
      throw redirect({ to: '/dashboards' })
    }

    return null
  },
  component: RobotsPage,
})
